import Settings from './settings'
import DeliveryAreas from './delivery-areas'
import Coupons from './coupons'

const state = {
    storeData: null,
    
    ...Settings.state,
    ...DeliveryAreas.state,
    ...Coupons.state,
};
const mutations = {
    ...Settings.mutations,
    ...DeliveryAreas.mutations,
    ...Coupons.mutations,

    SET_STORE_DATA(state, storeData){
        state.storeData = storeData;
    },
    UPDATE_STORE_DATA(state, data){
        Object.assign(state.storeData, data);
    },
};
const actions = {
    
    getStore({commit}, payload){
        let url = '/store';
        return window.axios.get(url).then(response=>{
            commit('SET_STORE_DATA', response.data);
        });
    },
    getStoreHomeData({commit}, payload){
        let url = '/store/home';
        return new Promise((resolve, reject)=>{
            window.axios.get(url).then(response=>{
                resolve(response);
            }).catch(e=>{
                reject(e);
            });
        });
    },
    updateStore({commit}, payload){
        let url = '/store';
        return new Promise((resolve, reject)=>{
            window.axios.put(url, payload.data).then(response=>{
                commit('UPDATE_STORE_DATA', response.data.data);
                resolve(response);
            }).catch(e=>{
                reject(e);
            });
        });
    },
    uploadLogoImage({commit}, payload){
        let url = '/store/logo';
        
        return window.axios.post(url, payload.data, {headers: {'Content-Type': 'multipart/form-data'}}).then(response=>{
            commit('UPDATE_STORE_DATA', response.data.data);
        });
    },
    uploadIconImage({commit}, payload){
        let url = '/store/icon';
        
        return window.axios.post(url, payload.data, {headers: {'Content-Type': 'multipart/form-data'}}).then(response=>{
            commit('UPDATE_STORE_DATA', response.data.data);
        });
    },

    ...Settings.actions,
    ...DeliveryAreas.actions,
    ...Coupons.actions,
};

export default {state, mutations, actions};